import { render, staticRenderFns } from "./HostVestInfo_new.vue?vue&type=template&id=cb135774&scoped=true"
import script from "./HostVestInfo_new.vue?vue&type=script&lang=js"
export * from "./HostVestInfo_new.vue?vue&type=script&lang=js"
import style0 from "./HostVestInfo_new.vue?vue&type=style&index=0&id=cb135774&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb135774",
  null
  
)

export default component.exports